import { type LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  testId?: string;
}

export function EmptyState({ icon: Icon, title, description, action, testId }: EmptyStateProps) {
  return (
    <div data-testid={testId} className="flex flex-col items-center justify-center rounded-xl bg-white p-8 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-slate-100">
        <Icon className="h-8 w-8 text-slate-400" />
      </div>
      <h3 className="mb-1 text-lg font-semibold text-slate-900">{title}</h3>
      {description && <p className="mb-4 text-sm text-slate-500">{description}</p>}
      {action && <div>{action}</div>}
    </div>
  );
}
